import {
  coerceLaunchDarklyFlagValue,
  FlagType,
  type FlagValueMap,
} from './flags';

type FlagValue = FlagValueMap[FlagType];
type FlagOverrides = Partial<Record<FlagType, FlagValue>>;

let snapshot: FlagOverrides = {};
const listeners = new Set<() => void>();

function emitChange() {
  listeners.forEach((fn) => fn());
}

export const devFlagOverrides = {
  getSnapshot(): FlagOverrides {
    return snapshot;
  },

  subscribe(listener: () => void): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },

  setOverride(flag: FlagType, value: FlagValue) {
    snapshot = { ...snapshot, [flag]: value };
    emitChange();
  },

  removeOverride(flag: FlagType) {
    const { [flag]: _, ...rest } = snapshot;
    snapshot = rest as FlagOverrides;
    emitChange();
  },

  setAll(flags: FlagType[], value: boolean | string) {
    const next = { ...snapshot };
    for (const flag of flags) {
      next[flag] = value;
    }
    snapshot = next;
    emitChange();
  },

  clearAll() {
    snapshot = {};
    emitChange();
  },

  // Stamp all known flags with their current LaunchDarkly values so the app
  // behaves exactly like the connected LD environment. Pass the raw flags
  // object returned by `useLDFlags()` from the LD React SDK.
  syncFromLD(ldFlagValues: Record<string, unknown>) {
    const next: FlagOverrides = {};
    for (const flag of Object.values(FlagType)) {
      const value = ldFlagValues[flag];
      if (value !== undefined) {
        next[flag] = coerceLaunchDarklyFlagValue(flag, value);
      }
    }
    snapshot = next;
    emitChange();
  },
};
